<template>
  <div class="cp-rule mobile" @click="handleClose">
    <div class="rule-wrapper" ref="wrap">
      <div>
        <div class="rule">
          <div class="rule-content">活动时间：<span style="color: #990000">2024年5月31日~2024年6月30日</span></div>
        </div>
        <div class="rule">
          <div class="rule-content">
            <span class="emphasis">十连抽奖：</span><br>奖励包含《原始征途》游戏道具及实物大奖，从页面公示的奖池中抽取，游戏道具品质由高到低为橙、紫、绿、黄、蓝，抽出概率递增；幸运的玩家，有机会在十连奖池之外，额外抽中实物大奖。
          </div>
        </div>
        <div class="rule">
          <div class="rule-content">
            <span class="emphasis">召集助力：</span><br>
            <span>
              1、默认有一次十连抽机会，还可召集兄弟助力增加机会；将页面分享给好友即可发起召集，好友助力成功后，便可增加一次10连抽的机会，最多额外增加17次。
            </span><br>
            <span>2、每位玩家有5次为不同好友助力的机会，受邀完成5次助力之后，将无法再为其他玩家进行助力。</span>
          </div>
        </div>
        <div class="rule">
          <div class="rule-content">
            <span class="emphasis">绑定角色：</span><br>
            领取奖励前，玩家需要通过登录巨人通行证绑定《原始征途》中的已创建角色，首次绑定后将无法换绑。
          </div>
        </div>
        <div class="rule">
          <div class="rule-content">
            <span class="emphasis">游戏道具领奖：</span><br>
            <span>
              1、可以在”我的奖励“界面中查看已经抽到的奖励，并且从已经抽到的奖励任意选择10个奖励领取到游戏中。
            </span><br>
            <span>2、活动期间，玩家只能领取一次奖励，领取的奖励数量必须为10个。</span>
            <br>
            <span>3、领奖后，奖励将自动发放至玩家绑定的《原始征途》角色账号之中，需自行前往查收。</span>
          </div>
        </div>
        <div class="rule">
          <div class="rule-content">
            <span class="emphasis">实物大奖领奖：</span><br>
            请获得实物奖励的玩家在15个工作日内填写收件信息，逾期未填写或误填收件信息视为放弃奖励资格，将在15个工作日内为已填收件信息的玩家发放实物奖励。
          </div>
        </div>
        <div class="rule">
          <div class="rule-content">
            <span class="emphasis">注意事项：</span><br>
            <span>
              1、如使用外挂等不正当方式参加本活动的，官方将有权取消用户参与及获奖资格。
            </span><br>
            <span>2、如有任何问题，请联系《原始征途》手游官方客服，客服微信号：jrsy24。</span>
          </div>
        </div>
      </div>
    </div>
    <Close is-mobile @close="handleClose" class="close"></Close>
  </div>
</template>

<script>
// 移动端头部
import store from '~/store/index';
import * as types from '~/store/mutation-type';
import { mapState } from "vuex";
import Close from '~/components/Close/close.vue';
import IScroll from '~/tools/iscroll.js'


export default {
  name: 'share',
  components: {Close},
  computed: {
    ...mapState({
      userInfo: state => state.userInfo
    })
  },
  mounted() {
    new IScroll(this.$refs.wrap,{
      mouseWheel: true,
      scrollbars: "custom",
      // 解决拖拽卡顿问题
      scrollX: false,
      scrollY: true,
      disablePointer: true,
      disableTouch: false,
      disableMouse: true,
      startX: 0,
      startY: 0,
    })
  },
  methods: {
    handleClose() {
      store.commit(types.HIDE_MODAL);
    }
  }
};
</script>
<style lang="stylus">
  .iScrollVerticalScrollbar {
      width: 0.08rem;
      height: 7.63rem;
      background-color: #b79d76;
      position: absolute;
      right: 0;
      top: 0;
      z-index: 1024;
      border: 1px solid #b79d76;
      box-sizing: border-box;
      border-radius: 0.04rem;
  }

  .iScrollIndicator {
    width: 0.06rem;
    background-color: #694815;
    border-radius: 0.03rem;
  }
</style>
<style lang="stylus" scoped>
  .cp-rule {
    position absolute
    width 6.66rem
    height 10.72rem
    background-size: 6.66rem 10.02rem;
    background-image url('./images/rule.png')
    background-repeat: no-repeat;
    background-position top center
    .rule-wrapper {
      position absolute
      top: 1.34rem
      left: 0.49rem;
      width: 5.68rem
      height: 7.43rem;
      overflow hidden
      padding-right 0.44rem
    }
    .rule {
      font-size 0.2rem
      line-height 1.5
      width 5.32rem
      margin-bottom 0.12rem
      display flex
      color #5c3a22
      &-seq {
        width 0.25rem
        height 0.25rem
        // background-image url('./images/dot.png')
        background-size: 0.25rem 0.25rem
        background-repeat: no-repeat
        margin-top 0.07rem
        margin-right 0.17rem
      }
      &-content {
        width 6.12rem
        text-align left
      }
      .emphasis {
        color #990000
        font-weight bold
        line-height 0.38rem
      }
    }
  }
</style>
